import React from 'react';
import { motion } from 'framer-motion';
import '../css/Profile.css';
import profilePic from '../assets/test.jpg';

const Profile = () => {
  return (
    <section id="profile" className="profile-section">
      <div className="profile-noise"></div>

      <motion.div
        className="profile-content"
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <span className="profile-tag">About Me</span>
        <h1>Building software that actually solves real problems.</h1>
        <h2>Full Stack Developer • AI Builder • Automotive Tech Founder</h2>
        <p>
          I design and build modern full-stack applications, mobile experiences,
          AI-powered tools, and secure backend systems. My work connects product design,
          engineering, and real-world operations — especially through projects like
          OZ Mechanic, where software meets automotive service.
        </p>

        <div className="profile-stats">
          <div className="profile-stat">
            <strong>Full Stack</strong>
            <span>React, FastAPI, MongoDB</span>
          </div>
          <div className="profile-stat">
            <strong>AI Systems</strong>
            <span>Voice, automation, assistants</span>
          </div>
          <div className="profile-stat">
            <strong>Founder Mindset</strong>
            <span>Real products, real users</span>
          </div>
        </div>
      </motion.div>

      <motion.div
        className="profile-image"
        initial={{ opacity: 0, x: 60, rotate: 4 }}
        whileInView={{ opacity: 1, x: 0, rotate: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
      >
        <div className="image-bg"></div>
        <div className="image-ring"></div>
        <img className="foreground-image" src={profilePic} alt="Onur Korkmaz" />
      </motion.div>
    </section>
  );
};

export default Profile;
